import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import { useOffice } from '../queries/offices';
import { useConfig } from './ConfigContext';

export default () => {
  const { officeId, siteName } = useConfig();
  const { data: office } = useOffice(officeId);

  if (!office?.logoUrl) return null;
  return <>
    <Helmet link={[{ rel: 'shortcut icon', href: office.logoUrl }]} />
    <Link to="/" className="navbar-brand pl-3 pl-sm-3">
      <img src={office.logoUrl} title={siteName || null} alt={siteName || null} />
    </Link>
  </>
}
